import React, { useState } from 'react';
import Modal from './Modal'; 

const PhoneSection = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isHoverText, setIsHoverText] = useState(false);
    const [isHoverBg, setIsHoverBg] = useState(false)

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    
    return (
        <div className="mainBlock__top-buttons-phone flex items-center gap-6">
            <a href={`tel:${props.data.phone[0].link}`} className={`flex items-center`}
            onMouseEnter={() => setIsHoverText(true)}
            onMouseLeave={() => setIsHoverText(false)}
            style={{
                color: isHoverText ? props.data.colors[0].colorRed : props.color
            }}>
                <span className="redKrug"></span> {props.data.phone[0].number}
            </a>
            <button onClick={handleOpenModal} className={`btn duration-300`}
            onMouseEnter={() => setIsHoverBg(true)}
            onMouseLeave={() => setIsHoverBg(false)}
            style={{
                color: props.data.colors[0].colorWhite,
                backgroundColor: isHoverBg ? props.data.colors[0].colorRedWhite : props.data.colors[0].colorRed
            }}>
                Перезвонить
            </button>
            <Modal data={props.data} isOpen={isModalOpen} onClose={handleCloseModal} />
        </div>
    );
};
 
export default PhoneSection;